import { render, staticRenderFns } from "./AccountModulesConfiguration.vue?vue&type=template&id=69fbd045&scoped=true&"
import script from "./AccountModulesConfiguration.vue?vue&type=script&lang=js&"
export * from "./AccountModulesConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./AccountModulesConfiguration.vue?vue&type=style&index=0&id=69fbd045&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fbd045",
  null
  
)

export default component.exports